import { render, staticRenderFns } from "./ChangeStatus.vue?vue&type=template&id=1700ef5b&scoped=true"
import script from "./ChangeStatus.vue?vue&type=script&lang=js"
export * from "./ChangeStatus.vue?vue&type=script&lang=js"
import style0 from "./ChangeStatus.vue?vue&type=style&index=0&id=1700ef5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1700ef5b",
  null
  
)

export default component.exports